import { render } from "./OnlineWaiver.vue?vue&type=template&id=3b90e020&scoped=true&ts=true"
import script from "./OnlineWaiver.vue?vue&type=script&lang=ts"
export * from "./OnlineWaiver.vue?vue&type=script&lang=ts"

import "./OnlineWaiver.vue?vue&type=style&index=0&id=3b90e020&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cpinkney\\Documents\\Dev\\GroupTrips3\\grouptrips-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b90e020"]])

export default __exports__